<template>
    <b-card class="mb-2" header-tag="header">
        <template #header>
            <h6 class="mb-0 text-center"><i class="fa fa-folder"></i> Datos Personales</h6>
        </template>
        <b-row>
            <b-col md>
                <div class="form-group">
                    <label for="">Primer Nombre</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                        disabled
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Segundo Nombre</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                        disabled
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Primer Apellido</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                        disabled
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Segundo Apellido</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                        disabled
                    />
                </div>
            </b-col>
            <div class="w-100"></div>
            <b-col md="6">
                <div class="form-group">
                    <label for="">Ciudad y Departamento de Nacimiento</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                        disabled
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Fecha de Nacimiento</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                    />
                </div>
            </b-col>
             <b-col md>
                <div class="form-group">
                    <label for="">Sexo</label>
                    <select class="form-control">
                        <option value="">F</option>
                        <option value="">M</option>
                    </select>
                </div>
            </b-col>
            <div class="w-100"></div>
            <b-col md>
                <div class="form-group">
                    <label for="">Tipo de Identificación</label>
                    <select class="form-control">
                        <option value="">CC</option>
                        <option value="">CE</option>
                        <option value="">NIT</option>
                        <option value="">TI</option>
                        <option value="">P</option>
                    </select>
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Nro. Identificación</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Fecha de Expedición</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Ciudad de Expedición</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                    />
                </div>
            </b-col>
            <div class="w-100"></div>
            <b-col md="6">
                <div class="form-group">
                    <label for="">Dirección de Residencia</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Barrio</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Estrato</label>
                    <select class="form-control">
                        <option value="">1</option>
                        <option value="">2</option>
                        <option value="">3</option>
                        <option value="">4</option>
                        <option value="">5</option>
                        <option value="">6</option>
                        <option value="">7</option>
                    </select>
                </div>
            </b-col>
             <div class="w-100"></div>
            <b-col md="6">
                <div class="form-group">
                    <label for="">Ciudad y Departamento</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Tipo de Vivienda</label>
                    <select class="form-control">
                        <option value="">Arrendada</option>
                        <option value="">Familiar</option>
                        <option value="">Propia</option>
                    </select>
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Tiempo en vivienda</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                    />
                </div>
            </b-col>
            <div class="w-100"></div>
            <b-col md>
                <div class="form-group">
                    <label for="">Telefono Fijo</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Celular 1</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                    />
                </div>
            </b-col>
           <b-col md="6">
                <div class="form-group">
                    <label for="">Correo Personal</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                    />
                </div>
            </b-col>
            <div class="w-100"></div>
            <b-col md>
                <div class="form-group">
                    <label for="">Celular 2</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                    />
                </div>
            </b-col>
           
            <b-col md>
                <div class="form-group">
                    <label for="">Estado Civil</label>
                    <select class="form-control">
                        <option value="">Casado</option>
                        <option value="">Separado</option>
                        <option value="">Soltero</option>
                        <option value="">Union Libre</option>
                        <option value="">Viudo</option>
                    </select>
                </div>
            </b-col>
             <b-col md="6">
                <div class="form-group">
                    <label for="">Correo Laboral</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                    />
                </div>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
